// ============================================================================
// Typed Route System
// ============================================================================

import { DEFAULT_LOCALE } from '../utils/i18n'
import { createUrlBuilders } from './builder'
import { routes } from './registry'

export { useRoutes } from './hooks'

// ============================================================================
// Route Builder Factory
// ============================================================================

/**
 * Create route builders for a specific locale.
 * Use this in data files or non-React contexts where useRoutes() hook can't be used.
 *
 * @example
 * export function getNavbarData(locale: string) {
 *   const routes = createRoutes(locale)
 *   return [
 *     { title: 'Features', href: routes.features() },
 *     { title: 'Pricing', href: routes.pricing() },
 *   ]
 * }
 */
export function createRoutes(locale: string = DEFAULT_LOCALE) {
  return createUrlBuilders(routes, locale)
}
